import axios from 'axios';

const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

class ImportFromFileService {
    static async sendFile(file, formType, username, assignedToValue) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('formType', formType);
            formData.append('username', username);
            formData.append('assignedTo', assignedToValue);
    
            const response = await axios.post(`${ROOT_URL}data/save/${formType}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            return response.data;
        } catch (error) {
            throw new Error('Failed to send the file');
        }
    }

    static async sendFillInFile(file, requestId, formType) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('formType', formType);
            formData.append('requestId', requestId);
    
            const response = await axios.post(`${ROOT_URL}data/fill/${requestId}/${formType}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            return response.data;
        } catch (error) {
            throw new Error('Failed to send the file');
        }
    }
}

export default ImportFromFileService;